/**
 * VCF-Generator. Nimmt die aktuellen Praxis-Kontaktdaten als Parameter,
 * damit dynamische Änderungen aus dem Admin sofort im Download landen.
 *
 * Erwartetes Format (camelCase):
 *   { name, role, street, zip, city, phone, phoneRaw, fax, faxRaw, email, webUrl }
 */
export function generateVCF(praxis) {
  const p = praxis || {};
  const parts = ["BEGIN:VCARD", "VERSION:3.0"];
  if (p.name) parts.push(`FN:${p.name}`);
  // N: aus dem Praxisnamen, wenn möglich (letzter Wortblock = Nachname)
  const nameParts = (p.name || "").split(" ").filter(Boolean);
  if (nameParts.length >= 2) {
    const last = nameParts[nameParts.length - 1];
    const first = nameParts.slice(0, -1).join(" ").replace(/^(Dr\.?\s?med\.?\s?)/i, "");
    const titles = /Dr\.?\s?med\.?/i.test(p.name || "") ? "Dr. med." : "";
    parts.push(`N:${last};${first};;${titles};`);
  }
  if (p.role) parts.push(`TITLE:${p.role}`);
  if (p.name) parts.push(`ORG:${p.name}`);
  if (p.phoneRaw) parts.push(`TEL;TYPE=WORK,VOICE:${p.phoneRaw}`);
  if (p.faxRaw) parts.push(`TEL;TYPE=WORK,FAX:${p.faxRaw}`);
  if (p.email) parts.push(`EMAIL;TYPE=WORK:${p.email}`);
  if (p.webUrl) parts.push(`URL:${p.webUrl}`);
  if (p.street || p.city || p.zip) {
    parts.push(`ADR;TYPE=WORK:;;${p.street || ""};${p.city || ""};;${p.zip || ""};Deutschland`);
  }
  parts.push("END:VCARD");
  return parts.join("\r\n");
}

export function downloadVCF(praxis) {
  const vcf = generateVCF(praxis);
  const blob = new Blob([vcf], { type: "text/vcard;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  const safe = (praxis?.name || "Kontakt").replace(/[^\w\-]+/g, "-").replace(/^-+|-+$/g, "");
  a.download = `${safe}.vcf`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 100);
}
